// extracted by mini-css-extract-plugin
export default {"intoFormContainer":"PhoneNumberForm_intoFormContainer__TtB98","modal-footer":"PhoneNumberForm_modal-footer__m7rON","modal-cancel-button":"PhoneNumberForm_modal-cancel-button__a9Gkz"};